import { ComplexValue } from '../types';
export function optionsContainValue(options: any, value: any) {
  return options.filter((e) => e.value === value).length > 0 ? true : false;
}
const defaultValue = [];
export function getOptionsOrDefault(valueItem: ComplexValue<number>, options: ComplexValue<number>[]) {
  let res = defaultValue;

  if (valueItem && options && optionsContainValue(options, valueItem.value)) {
    res = options;
  } else {
    if (valueItem && Object.keys(valueItem).length) {
      res = (options || defaultValue).concat(valueItem);
    } else if (options) {
      res = options;
    }
  }
  return res;
}
